import Header from "./Header";
import Assets from "./Assets";
import * as Cesium from 'cesium';
import { showAlert } from "helper";
import ProjectTag from "./ProjectTag";
import styled from "styled-components";
import Annotations from "./Annotations";
import ProjectName from "./ProjectName";
import ProjectType from "./ProjectType";
import { MapModalTypes } from "constant";
import MapModal from "components/MapModal";
import { Save } from '@mui/icons-material';
import ProjectEditBtn from "./ProjectEditBtn";
import CaptureButtons from "./CaptureButtons";
import ProjectLocation from "./ProjectLocation";
import { MapModalAnnotateStatus } from "constant";
import React, { useEffect, useState } from "react";
import SidebarIntro from "../../layout/SidebarIntro";
import CityScanModal from "components/CityScanModal";
import SiteScanModal from "components/SiteScanModal";
import ProjectDescription from "./ProjectDescription";
import { useSelector, useDispatch } from "react-redux";
import StreetScanModal from "components/StreetScanModal";
import useViewerStore from '../../../../store-zustand/viewer';
import useProjectStore from '../../../../store-zustand/project';
import useSearchStore from '../../../../store-zustand/searchbar';
import { BBOX_CENTROID, getBBOX, Zoomtopoint } from '../../../MapView/MapUtils';

const SavedDate = styled.div`
  margin-bottom: 28px;

  svg {
    color: #5A5A5A;
  }  

  span {
    font-family: Roboto;
    font-weight: 500;
    font-size: 13px;
    line-height: 15px;
    color: #5A5A5A;
    margin-left: 7px;
  }
`;

const SidebarProject = ({ project, onClose, onBack, onEditAnnotation, onAddAsset, onEditAsset, isCreate, completeCreateStatus, onMarketPlace }) => {
  const dispatch = useDispatch();
  const { keywords_response, setkeywords_response } = useSearchStore();
  const { search_result_visibility, setsearch_result_visibility, viewer } = useViewerStore();
  const { setcurrentAnnotationName, setcurrentAnnotationDescription, getprojectdataByid, setproject_modal_information, selectedCategoryPK, selectedCategory, setselectedCategory, selectedCategoryColor, setselectedCategoryColor, project_modal_information: project_data, project_id, update_project_data, DeleteProjectById, GetProjectTypeList, removeannotation, singleannotationeidtion, setreloadAnnotationsList, reloadAssetList } = useProjectStore();
  const siteScanActive = useSelector(state => state.settings.siteScanActive);
  const cityScanActive = useSelector(state => state.settings.cityScanActive);
  const streetScanActive = useSelector(state => state.settings.streetScanActive);
  const showMeasurementModal = useSelector(state => state.settings.showMeasurementModal);
  const [edit, setEdit] = useState(false);
  const [saved_date, setsaved_date] = useState(null);
  const [selectedPrjName, setselectedPrjName] = useState();
  const [selectedTypePK, setselectedTypePK] = useState(null);
  const [selectedLocation, setselectedLocation] = useState();
  const [defaultProjectType, setDefaultProjectType] = useState();
  const [selectedDescription, setselectedDescription] = useState();
  const [selectedType, setselectedType] = useState('Uncategorized');
  const [selectedAnnotation, setSelectedAnnotation] = useState(null);
  const [mapModal, setMapModal] = useState({ type: MapModalTypes.CurrentProject });

  useEffect(() => {
    if (!project_data) return;

    let address_props = project_data.info.address;
    if (address_props === undefined || address_props === ``) {
      address_props = project_data.info.place_name;
    }
    
    let country_props = project_data.info.country;
    let region_props = project_data.info.region;
    let place_props = project_data.info.place_name;
    let postal_code_props = project_data.info.postal_code;
    let location_string;
    if (address_props !== '' && place_props !== '' && postal_code_props !== '' && country_props !== '') {
      location_string = `${address_props}, ${place_props}, ${region_props} ${postal_code_props}, ${country_props}`;
    } else {
      location_string = region_props;
    }
    
    if (location_string.length > 40) {
      location_string = location_string.substring(0, 37);
      location_string = `${location_string} ...`;
    }
    
    setselectedLocation(location_string);
    setMapModal({ ...project_data.info, type: MapModalTypes.CurrentProject })
  }, [project_data])

  useEffect(() => {
    dispatch({ type: 'TOGGLE_MEASUREMENT_ENABLE', show: true });
    dispatch({ type: 'TOGGLE_PIN_ENABLE', show: true });
    dispatch({ type: 'TOGGLE_MAP_MODAL', show: true });
  }, [])

  useEffect(() => {
    if (isCreate) setEdit(true);

    if (project_data) {
      setMapModal({ ...project_data.info, type: MapModalTypes.CurrentProject });
    } else {
      setMapModal({ type: MapModalTypes.CurrentProject });
    }
    
    dispatch({ type: 'TOGGLE_ANNOTATION_MODAL', show: false });
    if (!edit) setsearch_result_visibility(false);
  }, [isCreate, project_data, edit, setsearch_result_visibility]);

  useEffect(() => {
    async function fetchData() {
      const project_info = await getprojectdataByid(project_id);
      let updation_date = project_info[0]?.fields?.UPDATED;
      let creation_date = project_info[0]?.fields?.CREATED;
      if (updation_date !== null) {
        setsaved_date(updation_date);
      } else {
        setsaved_date(creation_date);
      }

      let projectname = project_info[0].fields?.NAME;
      setselectedPrjName(projectname);
      setselectedDescription(project_info[0].fields?.DESCRIPTION);
      dispatch({ type: 'TOGGLE_ANNOTATION_MODAL', show: false });
      dispatch({ type: 'TOGGLE_MAP_TOOL', show: true });
      dispatch({ type: 'TOGGLE_DATE_PAGINATOR', show: true });
      window.history.pushState("", "", `/projects/${project_id}`);
    }
    
    fetchData();
  }, [edit, project_id, reloadAssetList]);

  useEffect(() => {
    async function fetchData() {
      const Type_list = await GetProjectTypeList();
      if (Type_list !== 'Error') {
        if (edit === true && isCreate === true) {
          setDefaultProjectType(Type_list[0]);
        }
      } else {
        showAlert('error', 'Error while getting the Types list.')
      }
    }

    fetchData();
  }, [GetProjectTypeList, edit, isCreate]);

  useEffect(() => {
    if (singleannotationeidtion !== undefined) handleAnnotationEdit(singleannotationeidtion);
  }, [singleannotationeidtion])

  const handleEdit = () => {
    if (edit === true) {
      let location_string;
      if (project_data.info.address !== '' && project_data.info.place_name !== '' && project_data.info.postal_code !== '' && project_data.info.country !== '') {
        location_string = `${project_data.info.address}, ${project_data.info.place_name}, ${project_data.info.region} ${project_data.info.postal_code}, ${project_data.info.country}`;
      } else {
        location_string = project_data.info.region;
      }

      if (location_string.length > 40) {
        location_string = location_string.substring(0, 37);
        location_string = `${location_string} ...`;
      }

      setselectedLocation(location_string);
      const BBOX = getBBOX(viewer);
      const Centroid = BBOX_CENTROID(BBOX[0], BBOX[1], BBOX[2], BBOX[3]);
      let projectName = selectedPrjName;
      let address = project_data.info.address;
      if (address === undefined || address === ``) {
        address = project_data.info.place_name;
      }
      
      let country = project_data.info.country;
      let region = project_data.info.region;
      let place = project_data.info.place_name;
      let postal_code = project_data.info.postal_code;
      let TEMPERATURE = project_data.info.temperature;
      let TYPEID = selectedTypePK;
      if (TYPEID === null) {
        if (edit === true && isCreate === true) {
          TYPEID = defaultProjectType?.pk;
          setselectedTypePK(defaultProjectType?.pk);
          setselectedCategory(defaultProjectType?.fields?.TYPENAME);
        } else {
          TYPEID = selectedCategoryPK;
        }
      } else {
        setselectedCategory(selectedType);
      }

      const data_to_update = {
        projectID: project_id,
        description: selectedDescription,
        TypeId: TYPEID,
        postal_code: postal_code,
        place: place,
        region: region,
        country: country,
        address: address,
        Centroid: Centroid,
        BBOX: BBOX,
        NAME: projectName,
        TEMPERATURE: TEMPERATURE
      }
      
      setproject_modal_information({
        info: {
          address: address,
          place_name: place,
          postal_code: postal_code,
          region: region,
          country: country,
          description: selectedDescription,
          temperature: TEMPERATURE,
          location: location_string,
          projectname: projectName
        }
      });
      
      const update = update_project_data(data_to_update);
      if (update === 'Error') showAlert('error', 'An error occured while updating the data.');
    }

    setkeywords_response();
    setsearch_result_visibility(false);
    completeCreateStatus();
    setEdit(!edit);
  };

  const handle_Description = (info) => {
    setselectedDescription(info);
  }

  const handle_location = (info) => {
    setselectedLocation(info);
  }

  const handle_selected_project = (info) => {
    setselectedType(info.fields.TYPENAME);
    setselectedCategoryColor(info.fields.COLOR);
    setselectedTypePK(info.pk);
  }
  
  const handle_selected_name = (info) => {
    setselectedPrjName(info);
  }
  
  const handleChangeField = (fieldName, status) => {
    setMapModal((mapModal) =>
      Object.assign({
        ...mapModal,
        [fieldName]: status,
      })
    );

    dispatch({ type: 'TOGGLE_ANNOTATION_MODAL', show: false });
  };

  const handleAnnotationSelect = (annotationItem, annotationindex) => {
    window.actualAnnotationId = annotationindex;
    let entity = window.GlobalAnnotationEntities.entities.getById(annotationItem.annotationId);
    if (entity.polygon) {
      const boundingSphere = Cesium.BoundingSphere.fromPoints(entity.polygon.hierarchy._value.positions);
      viewer.camera.flyToBoundingSphere(boundingSphere, { offset: new Cesium.HeadingPitchRange(0, Cesium.Math.toRadians(-90), 0) });
    } else if (entity.polyline) {
      const boundingSphere = Cesium.BoundingSphere.fromPoints(entity.polyline.positions._value);
      viewer.camera.flyToBoundingSphere(boundingSphere, { offset: new Cesium.HeadingPitchRange(0, Cesium.Math.toRadians(-90), 0) });
    } else {
      let coordinateString = annotationItem.description.replace(' ', '');
      let coordinate = coordinateString.split(',');
      let longitude = parseFloat(coordinate[0]);
      let latitude = parseFloat(coordinate[1]);
      Zoomtopoint(viewer, longitude, latitude);
    }

    setSelectedAnnotation(annotationItem);
    setMapModal((mapModal) =>
      Object.assign({
        ...mapModal,
        ...annotationItem,
      })
    );

    dispatch({ type: 'TOGGLE_ANNOTATION_MODAL', show: false });
  };

  const handleAnnotationEdit = (annotationItem, annotationindex) => {
    window.actualAnnotationId = annotationindex;
    setcurrentAnnotationName(annotationItem.annotationname);
    setcurrentAnnotationDescription(annotationItem.annotationdescription);
    let entity = window.GlobalAnnotationEntities.entities.getById(annotationItem.annotationId);
    if (Cesium.defined(entity)) {
      window.GlobalAnnotationEntities.entities.getById(annotationItem.annotationId).show = true;
    }

    let entityoutline = window.GlobalAnnotationEntities.entities.getById(`${annotationItem.annotationId}PolygonOutline`);
    if (Cesium.defined(entityoutline)) {
      window.GlobalAnnotationEntities.entities.getById(`${annotationItem.annotationId}PolygonOutline`).show = true;
    }
    
    dispatch({ type: 'TOGGLE_MEASUREMENT_ENABLE', show: true });
    dispatch({ type: 'TOGGLE_PIN_ENABLE', show: true });

    if (entity.polygon) {
      const boundingSphere = Cesium.BoundingSphere.fromPoints(entity.polygon.hierarchy._value.positions);
      viewer.camera.flyToBoundingSphere(boundingSphere, { offset: new Cesium.HeadingPitchRange(0, Cesium.Math.toRadians(-90), 0) });
    } else if (entity.polyline) {
      const boundingSphere = Cesium.BoundingSphere.fromPoints(entity.polyline.positions._value);
      viewer.camera.flyToBoundingSphere(boundingSphere, { offset: new Cesium.HeadingPitchRange(0, Cesium.Math.toRadians(-90), 0) });
    } else {
      let coordinateString = annotationItem.description.replace(' ', '');
      let coordinate = coordinateString.split(',');
      let longitude = parseFloat(coordinate[0]);
      let latitude = parseFloat(coordinate[1]);
      Zoomtopoint(viewer, longitude, latitude);
    }

    setSelectedAnnotation(annotationItem);
    onEditAnnotation({ ...project, ...annotationItem });
  };

  const handleAnnotationDelete = async (annotationItem) => {
    let ID = annotationItem.annotationId;
    let keyword = {};
    keyword.IDANNOTATION = ID;
    let annotationREmovedId = await removeannotation(keyword);
    let removedpolygonoutline = viewer.entities.getById(`${ID}PolygonOutline`);
    if (Cesium.defined(removedpolygonoutline)) {
      viewer.entities.remove(removedpolygonoutline);
    }
    
    if (annotationREmovedId !== 'Error') {
      showAlert('success', 'Annotation removed successfully!')
      setreloadAnnotationsList(annotationREmovedId);
    } else {
      showAlert('error', 'An error occured while removing the Annotation.')
    }
  };
  
  const handleStatusChange = (status) => {
    if (status === MapModalAnnotateStatus.Edit) handleAnnotationEdit(selectedAnnotation);
  };

  const deletefunction = async (param) => {
    const keywork = { PROJECTID: param }
    const response = await DeleteProjectById(keywork);
    if (response !== 'error') {
      showAlert('success', 'Project removed successfully!')
      window.location.reload(false);
    } else {
      showAlert('error', 'Error occured while deleting the Project.')
    }
  }

  const backtoProjectModalView = () => {
    setMapModal({ ...project_data.info, type: MapModalTypes.CurrentProject });
  }

  const modalfunction = () => {
    if (mapModal) {
      if (showMeasurementModal === false) {
        return (
          <MapModal
            backtoProjectModalView={backtoProjectModalView}
            type={mapModal.type}
            info={mapModal}
            status={mapModal.status}
            onChangeStatus={handleStatusChange}
            goToEditAnnoationPage={handleAnnotationEdit}
            onChangeDimension={(dimension) => {
              let entity = window.GlobalAnnotationEntities.entities.getById(selectedAnnotation.annotationId);
              if (entity && entity.polygon) {
                entity.polygon.perPositionHeight = (dimension === "2D" ? true : false);
                var outline = window.GlobalAnnotationEntities.entities.getById(`${entity.id}PolygonOutline`);
                if (outline && outline.polyline) {
                  outline.polyline.clampToGround = (dimension === "2D" ? false : true);
                }
              } else if (entity && entity.polyline) {
                entity.polyline.clampToGround = (dimension === "2D" ? false : true);
              } else if (entity && entity.billboard) {
                entity.billboard.heightReference = (dimension === "2D" ? Cesium.HeightReference.CLAMP_TO_GROUND : Cesium.HeightReference.NONE)
                if (dimension === "2D") {
                  selectedAnnotation.value = (Math.round(selectedAnnotation.terrainHeight * 100) / 100) + " m";
                  handleChangeField("value", (Math.round(selectedAnnotation.terrainHeight * 100) / 100) + " m")
                } else {
                  selectedAnnotation.value = (Math.round(selectedAnnotation.height * 100) / 100) + " m";
                  handleChangeField("value", (Math.round(selectedAnnotation.height * 100) / 100) + " m")
                }
              }
              
              selectedAnnotation.dimension = dimension;
              handleChangeField("dimension", dimension)
            }}
            onAddAsset={() => {
              const projectModal = { ...project_data.info, type: MapModalTypes.CurrentProject }
              onAddAsset(projectModal);
            }}
          />)
      } else {
        setMapModal();
        return <></>
      }
    }
  }

  return (
    <>
      <Header projectID={project_id} deletefunction={deletefunction} onClose={onClose} onBack={onBack} edit={edit} returnToOriginalPage={() => setEdit(false)} />
      <SavedDate>
        <Save />
        <span>Saved {saved_date}</span>
      </SavedDate>
      <SidebarIntro>
        <ProjectTag edit={edit} tag={selectedCategory} color={selectedCategoryColor} />
        <ProjectEditBtn edit={edit} handleEdit={handleEdit} />
        <ProjectName edit={edit} name={(selectedPrjName === null || selectedPrjName === 'null') ? 'Untitled' : selectedPrjName} handle_selected_name={handle_selected_name} />
        <ProjectType edit={edit} isCreate={isCreate} handle_selected_project={handle_selected_project} tag={selectedCategory} EditedcategoryId={selectedCategoryPK} />
        <ProjectDescription edit={edit} description={selectedDescription} handle_Description={handle_Description} />
        <ProjectLocation edit={edit} location={selectedLocation} handle_location={handle_location} />
        <CaptureButtons
          onAddAssets={() => {
            dispatch({ type: 'SET_SELECTED_ION_ASSET', selectedIonAsset: null });
            const projectModal = { ...project_data.info, type: MapModalTypes.CurrentProject }
            onAddAsset(projectModal);
          }}
          onMarketPlace={onMarketPlace}

        />
      </SidebarIntro>
      { search_result_visibility && <ul style={{ margin: '0 -2.5rem' }}>{keywords_response}</ul>}
      <Annotations onSelect={handleAnnotationSelect} onEdit={handleAnnotationEdit} onDelete={handleAnnotationDelete} projectID={project_id} />
      <Assets onEdit={onEditAsset}
        onAdd={() => {
          dispatch({ type: 'SET_SELECTED_ION_ASSET', selectedIonAsset: null });
          const projectModal = { ...project_data.info, type: MapModalTypes.CurrentProject }
          onAddAsset(projectModal);
        }}
      />
      {cityScanActive || streetScanActive || siteScanActive ? null : modalfunction()}
      {cityScanActive ? <CityScanModal /> : null}
      {streetScanActive ? <StreetScanModal /> : null}
      {siteScanActive ? <SiteScanModal /> : null}
    </>
  );
};

export default SidebarProject;